import { MY_PERMISSIONS } from '@src/constants'
import { myPermissionsGuard } from '@src/router/guards'
import { DOCUMENT_WIZARD_MODES, ROUTES_DOCUMENT_WIZARD } from './constants'

export default {
    path: 'document-wizard',
    name: ROUTES_DOCUMENT_WIZARD.BASE.name,
    component: () => import('./ModuleDocumentWizard'),
    props: route => ({
        ...route.params
    }),
    redirect: to => ({
        name: ROUTES_DOCUMENT_WIZARD.WIZARD.name,
        params: { ...to.params }
    }),
    children: [
        {
            path: 'document/:documentId',
            name: ROUTES_DOCUMENT_WIZARD.WIZARD.name,
            component: () => import('./DocumentWizard'),
            props: () => ({
                mode: DOCUMENT_WIZARD_MODES.EDIT
            }),
            meta: {
                pageTitle: 'DOCUMENT_WIZARD.TITLE',
                requiresAuth: true,
                guards: [myPermissionsGuard],
                permissions: [MY_PERMISSIONS.DOCUMENT_WIZARD_ACCESS]
            }
        },
        {
            path: `document/:documentId/:mode`,
            name: ROUTES_DOCUMENT_WIZARD.SETUP_DOCUMENT.name,
            component: () => import('./DocumentWizard'),
            props: route => ({
                mode: route.params.mode
            }),
            meta: {
                pageTitle: 'DOCUMENT_WIZARD.TITLE',
                requiresAuth: true,
                guards: [myPermissionsGuard],
                permissions: [MY_PERMISSIONS.DOCUMENT_WIZARD_ACCESS]
            }
        },
        {
            path: `document/:documentId/:mode/template`,
            name: ROUTES_DOCUMENT_WIZARD.CREATE_TEMPLATE.name,
            component: () => import('./create/CreateFromTemplate'),
            props: route => ({
                mode: route.params.mode
            }),
            meta: {
                pageTitle: 'DOCUMENT_WIZARD.TITLE',
                requiresAuth: true,
                guards: [myPermissionsGuard],
                permissions: [MY_PERMISSIONS.DOCUMENT_WIZARD_ACCESS]
            }
        }
    ]
}
